<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Kontaktni podatki se lahko razlikujejo od naročniških. Uporabili jih bomo za namen urejanja
          naročniškega razmerja (obisk omrežnega tehnika, dostava opreme, itd.)
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaUporabniskiPodatki'
}
</script>
<style scoped>
.info-okvir {
  width: 650px;
  height: 85px;
  display: flex;
}

@media only screen and (max-width: 1100px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Pregledstoritev/InfoKomponentaUporabniskiPodatki.vue